import {
	timetableRequestIdentity,
	useTimetableRequestIdentity,
} from "@features/timetables/settingsQueries";
import {
	queryOptions,
	useQuery,
	useSuspenseQuery,
} from "@tanstack/react-query";
import { getExtendedStudentPersona } from "./api";

export const studentExtendedPersonaQueryKey = (
	id: string,
	identity = timetableRequestIdentity(),
) => ["extendedPersona", ...identity, id] as const;

export function studentExtendedPersonaQueryOptions(
	id: string,
	identity = timetableRequestIdentity(),
) {
	return queryOptions({
		queryKey: studentExtendedPersonaQueryKey(id, identity),
		queryFn: () => getExtendedStudentPersona(id),
		staleTime: 1 * 60 * 1000, // 1m
		gcTime: 60 * 60 * 1000, // keep cached for 1h
	});
}

export function useStudentExtendedPersona(id: string) {
	return useQuery(
		studentExtendedPersonaQueryOptions(id, useTimetableRequestIdentity()),
	);
}

export function useStudentExtendedPersonaSuspense(id: string) {
	return useSuspenseQuery(
		studentExtendedPersonaQueryOptions(id, useTimetableRequestIdentity()),
	);
}
